<template>
  <div>
    <div class="pdfContent">
      <img
        class="icon-add"
        src="../assets/imgs/zoom.png"
        @click="iconAdd"
      >
      <img
        class="icon-jian"
        src="../assets/imgs/shrink.png"
        @click="iconJian"
      >
      <canvas
        v-for="page in pages"
        :id="'canvas'+page"
        :key="page"
      ></canvas>
      <p style="position:fixed;top:10px;right:10px">{{nowPage}}/{{pages}}</p>
    </div>
    <div
      class="dialogMask"
      v-show="isPhoto"
    >
      <div class="dialogBox">
        <p class="dialogTit">请拍摄学时照片</p>
        <input
          name="url"
          type="file"
          capture="camera"
          accept="image/*"
          id="upload_input"
          @change="shangc"
        />
      </div>
         <div class="ansDialog" v-show="isShowAns">
        <p class="dailogT">请选择正确答案进行验证</p>
        <div class="ansDia-que">
          {{ randNum1 }} + {{ randNum2 }} = <span class="ansDiv"></span>
        </div>
        <p class="errorMsg"><span v-if="isError">答案错误！请重新选择</span></p>
        <ul class="ansItems">
          <li :class="{activeItem:ansI === 0}" @click='clickAns(0)'>{{Number(randNum1) + Number(randNum2)}}</li>
          <li :class="{activeItem:ansI === 1}" @click='clickAns(1)'>{{item1}}</li>
          <li :class="{activeItem:ansI === 2}" @click='clickAns(2)'>{{item2}}</li>
          <li :class="{activeItem:ansI === 3}" @click='clickAns(3)'>{{item3}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import PDF from 'pdfjs-dist'
import { Toast, MessageBox } from 'mint-ui'
// , summaryStatus, uploadJPG, uploadStudyTime, videoTimeInterval,
import {
  uploadImgSize,
  summaryStatus,
  uploadJPG,
  uploadStudyTime,
  getAllConfigs
} from '../../src/api/Api'
PDF.disableWorker = true
let canvas = ''
let ctx = ''
let dpr = ''
let bsr = ''
let ratio = ''
let viewport = ''
let timer = 0
let lastTimeP = 0
let lastTimeT = 0
let timeInterval
let imgFile
export default {
  name: 'pdf',
  data () {
    return {
      width: 100,
      pages: 0,
      nowPage: 1,
      pdfDoc: '',
      progress: '0%',
      imgSize: '',
      vPutTime: '',
      aPutTime:'',//定时答题
      playNotesDetailId: '',
      videoObj: this.$route.query.videoObj,
      totalduration: 0,
      playOrPause: true,
      snapPT: 0,
      snapDT: 0,
      isEffective: true,
      isFinish: 0,
      isPhoto: false,
      notesId: '',
      randNum1: 0,
      randNum2: 0,
      item1:0,
      item2:0,
      item3:0,
      ansI:4
    }
  },
  created: function () {
    this.loadFile(this.pdfUrl)
  },
  mounted: function () {
    timeInterval = setInterval(this.add, 1000) // 计时器
    window.addEventListener('scroll', this.handleScroll, true)

    summaryStatus({
      employeeId: sessionStorage.getItem('userId'),
      studyPlanId: this.videoObj.study_plan_id
    }).then(res => {
      if (res.data.code === 0) {
        // Toast('未达到计划学时！')
      } else if (res.data.code === 1) {
        // Toast('已达到计划学时！')
        this.isEffective = false
      }
    })

    // 获取上传图片大小
    uploadImgSize().then(res => {
      this.imgSize = res.data.returnDate.imageSize
      console.log('上传图片大小：： ：' + this.imgSize)
    })
   // 参数配置获取
    getAllConfigs().then(res => {
      if (res.data.returnCode === 1) {
        this.vPutTime = res.data.returnDate.pzjg[0].secondMark //拍照时间间隔
        this.aPutTime=res.data.returnDate.yzmzq[0].secondMark   // 获取答题验证时间间隔
      } else {
        Toast(res.data.returnMsg)
        this.$router.go(-1)
      }
    })


    if (
      this.videoObj.play_point !== null &&
      this.videoObj.play_point !== undefined &&
      this.videoObj.play_time !== undefined &&
      this.videoObj.play_time !== null
    ) {
      if (
        Number(this.videoObj.play_point) > Number(this.videoObj.play_time) ||
        Number(this.videoObj.play_point) === Number(this.videoObj.play_time)
      ) {
        clearInterval(timeInterval) // 学过了 就不上传学时了
        MessageBox({
          title: '提示',
          message: '学过了，再学也不计学时了! <br/>你确定还要学吗?'
          // showCancelButton: true
        }).then(action => {
          if (action === 'confirm') {
            // 确认的回调
            console.log('再学一次')
          } else {
            return false
          }
        })
      } else {
        document.getElementsByClassName('pdfContent')[0].scrollTop = 0
      }
    }
  },
  props: ['pdfUrl'],
  methods: {
    add: function () {
      timer++
      console.log(timer - lastTimeP + '########' + timer++)
      // if (timer < 200) {
      if (timer < Number(this.videoObj.play_time) * 60) {
        console.log(lastTimeP + 'addPic########' + timer++)
        // 定时拍照
        if (timer - lastTimeP > this.vPutTime) {
          // if ((timer - lastTimeP) >= 20) {
          lastTimeP = timer
          this.takePhoto()
        }
        //定时答题验证
           // if (Math.floor(video.currentTime) - this.snapPT >= 60) {
          if (timer - lastTimeP > this.aPutTime && this.aPutTime !== 0) {
            lastTimeP = timer
            this.showQcheck()
          }

        console.log(lastTimeT + 'addTime########' + timer++)
      } else {
        // 达到计划学时
        this.isFinish = 1
        clearInterval(timeInterval)
        this.updateTime()
      }
    },
    takePhoto: function () {
      console.log('拍照上传。。。')
      clearInterval(timeInterval)
      this.isPhoto = true
    },
    showQcheck(){ //定时答题验证
      var _this=this
      _this.randNum1=Math.floor(Math.random()*10)
      _this.randNum2=Math.floor(Math.random()*10)
      var rightV=Number(_this.randNum1)+Number(_this.randNum2)
      _this.item1=Math.floor(Math.random()*10)
      _this.item2=_this.item1+Math.floor(Math.random()*10)+2
      _this.item3=_this.item2+Math.floor(Math.random()*10)
      _this.isShowAns = true
      // 随机放置正解位置
      var x = document.querySelectorAll(".ansItems li")
      for (var i = 0; i < x.length; i++) {
          x[i].style.order = Math.floor(Math.random()*10)
          x[i].addEventListener('click',function(){
            if(Number(this.innerHTML)===rightV){
              console.log('truetrue')
              Toast('回答正确！继续学习吧')
              _this.isShowAns = false
              _this.isError= false
              video.play()
            } else {
               console.log('falsefalse')
              _this.isError= true
            }
          })

      }
    },
    clickAns(i){
      this.ansI=i
    },
    // 上传有效/无效学时
    updateTime () {
      if (
        Number(this.videoObj.play_point) > Number(this.videoObj.play_time) ||
        Number(this.videoObj.play_point) === Number(this.videoObj.play_time)
      ) {
        console.log('已学，不上传')
        return false
      }
      uploadStudyTime({
        employeeId: sessionStorage.getItem('userId'),
        studyPlanId: this.videoObj.study_plan_id,
        companyId: this.videoObj.company_id,
        industryId: this.videoObj.industry_id,
        courseId: this.videoObj.id,
        studyMonth: this.videoObj.study_month,
        playNotesDetailId: this.playNotesDetailId,
        trueTime: Math.floor(Number(this.totalduration)),
        playedTime: 0,
        playPoint: this.videoObj.play_time,
        playTime: this.videoObj.play_time,
        isFinish: this.isFinish
      }).then(res => {
        if (res.data.code === 200) {
          console.log('上传成功')
          this.notesId = res.data.data.notesId
          this.takePhoto()
        } else {
          console.log('上传失败')
        }
      })
    },
    shangc () {
      console.log('图片上传notesId' + this.notesId)
      let _this = this
      let file = document.getElementById('upload_input').files[0]
      // 判断图片类型
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/JPG'
      ) {
        var isJPG = true
      } else {
        isJPG = false
      }
      // 判断图片大小
      // const isLt2M = file.size / 1024 / 1024 < 2
      const isLt2M = file.size / 1024 / 1024 < this.imgSize
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG/JPEG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      // 创建一个HTML5的FileReader对象
      var reader = new FileReader()
      // 创建一个img对象
      var img = new Image()
      // let filename = options.filename
      if (file) {
        reader.readAsDataURL(file)
      }
      if (isJPG && isLt2M) {
        reader.onload = e => {
          // let base64Str = reader.result.split(',')[1]
          img.src = e.target.result
          imgFile = e.target.result
          // base64地址图片加载完毕后执行
          img.onload = function () {
            // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
            var canvas = document.createElement('canvas')
            var context = canvas.getContext('2d')
            // 图片原始尺寸
            var originWidth = this.width
            var originHeight = this.height
            // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
            var maxWidth = 300
            var maxHeight = 300
            // 目标尺寸
            var targetWidth = originWidth
            var targetHeight = originHeight
            // 图片尺寸超过最大尺寸的限制
            if (originWidth > maxWidth || originHeight > maxHeight) {
              if (originWidth / originHeight > maxWidth / maxHeight) {
                // 更改宽度，按照宽度限定尺寸
                targetWidth = maxWidth
                targetHeight = Math.round(
                  maxWidth * (originHeight / originWidth)
                )
              } else {
                targetHeight = maxHeight
                targetWidth = Math.round(
                  maxHeight * (originWidth / originHeight)
                )
              }
            }
            // 对图片进行缩放
            canvas.width = targetWidth
            canvas.height = targetHeight
            // 清除画布
            context.clearRect(0, 0, targetWidth, targetHeight)
            // 图片压缩
            context.drawImage(img, 0, 0, targetWidth, targetHeight)
            /* 第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高 */
            // 压缩后的base64文件
            imgFile = canvas.toDataURL('image/jpeg', 0.92)
            uploadJPG({
              employeeId: sessionStorage.getItem('userId'),
              videoPlayNotesId: this.notesId,
              uploadTime: _this.dateFormat(),
              studyPlanId: _this.videoObj.study_plan_id,
              coursewareId: _this.videoObj.id,
              imageDate: imgFile
            }).then(res => {
              if (res.data.code === 200) {
                console.log('thenthenthen::::' + res.data.code)
                document.getElementById('upload_input').value = ''
                Toast('学习照片上传成功，待审核......')
                _this.isPhoto = false
                timeInterval = setInterval(_this.add, 1000) // 计时器
              } else {
                Toast('学习照片上传失败，请重试')
                _this.isPhoto = true
              }
            })
          }
        }
      }
    },
    dateFormat () {
      var date = new Date()
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      )
    },
    /* 加载PDF文件 */
    loadFile: function (url) {
      let _this = this
      PDF.getDocument(url).then(function (pdf) {
        _this.pdfDoc = pdf
        _this.pages = _this.pdfDoc.numPages

        _this.$nextTick(() => {
          _this.renderPage(1)
        })
      })
    },
    /* 渲染PDF文件 */
    renderPage: function (num) {
      let _this = this
      this.pdfDoc.getPage(num).then(function (page) {
        canvas = document.getElementById('canvas' + num)
        ctx = canvas.getContext('2d')
        dpr = window.devicePixelRatio || 1 // 设备像素比
        bsr =
          ctx.webkitBackingStorePixelRatio ||
          ctx.mozBackingStorePixelRatio ||
          ctx.msBackingStorePixelRatio ||
          ctx.oBackingStorePixelRatio ||
          ctx.backingStorePixelRatio ||
          1 // 浏览器在渲染canvas之前会用几个像素来来存储画布信息,类似img
        ratio = dpr / bsr
        viewport = page.getViewport(
          screen.availWidth / page.getViewport(1).width
        ) // 用户网页的可视区域
        canvas.width = viewport.width * ratio // 画布大小,默认值是width:300px,height:150px
        canvas.height = viewport.height * ratio
        canvas.style.width = viewport.width + 'px' // 画布的框架大小
        canvas.style.height = viewport.height + 'px'
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
        var renderContext = {
          canvasContext: ctx,
          viewport: viewport
        }
        page.render(renderContext)
        if (_this.pages > num) {
          _this.renderPage(num + 1)
        } else {
          if (
            _this.progress !== '0%' &&
            _this.progress !== '100%' &&
            _this.progress !== 'undefined'
          ) {
            let progressNum = (
              Number(_this.progress.split('%')[0]) * 0.01
            ).toFixed(2)
            let hadRead = _this.pages * progressNum
            _this.nowPage = Math.floor(hadRead)
            console.log(progressNum + 'hadRead:' + hadRead)
            document.getElementsByClassName('pdfContent')[0].scrollTop =
              hadRead * viewport.height
          }
        }
      })
    },
    /* 放大PDF文件 */
    iconAdd: function () {
      let pageNum = document.querySelectorAll('canvas').length
      this.width += 20
      for (var i = 0; i < pageNum; i++) {
        document.querySelectorAll('canvas')[i].style.width = this.width + '%'
      }
    },
    /* 缩小PDF文件 */
    iconJian: function () {
      if (this.width === 100) return
      let pageNum = document.querySelectorAll('canvas').length
      this.width -= 20
      for (var i = 0; i < pageNum; i++) {
        document.querySelectorAll('canvas')[i].style.width = this.width + '%'
      }
    },
    handleScroll () {
      console.log('!!~~!~!~!')
      let onePageH = viewport.height
      let pdfCon = document.getElementsByClassName('pdfContent')[0]
      this.nowPage =
        this.nowPage < this.pages
          ? Math.ceil(pdfCon.scrollTop / onePageH) + 1
          : 1
    }
  },
  destroyed () {
    console.log('销毁了！！！！')
    clearInterval(timeInterval)
    window.removeEventListener('scroll', this.handleScroll, true)
  }
}
</script>

<style>
.pdfContent {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: scroll;
}
.icon-add,
.icon-jian {
  width: 1rem;
  height: 1rem;
  position: fixed;
  right: 0.3rem;
  bottom: 3.52rem;
  z-index: 100;
}
.icon-jian {
  bottom: 2.22rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pdf.vue